'use strict';

var cov_19u8wzgkma = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/auth/auth.logout.controller.js',
        hash = 'a7f72bef34a36b34ed025147d7751af61ca592d2',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/auth/auth.logout.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 27,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 56
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 19
                },
                end: {
                    line: 10,
                    column: 23
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 28
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 27
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 24
                }
            },
            '7': {
                start: {
                    line: 21,
                    column: 12
                },
                end: {
                    line: 24,
                    column: 15
                }
            },
            '8': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 57
                }
            },
            '9': {
                start: {
                    line: 23,
                    column: 16
                },
                end: {
                    line: 23,
                    column: 35
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 27,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Controller',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 57
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 16,
                        column: 17
                    },
                    end: {
                        line: 16,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 28
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 16
            },
            '3': {
                name: 'logout',
                decl: {
                    start: {
                        line: 20,
                        column: 17
                    },
                    end: {
                        line: 20,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 26
                    },
                    end: {
                        line: 25,
                        column: 9
                    }
                },
                line: 20
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 21,
                        column: 38
                    },
                    end: {
                        line: 21,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 50
                    },
                    end: {
                        line: 24,
                        column: 13
                    }
                },
                line: 21
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_19u8wzgkma.s[0]++;
(function () {
    'use strict';

    cov_19u8wzgkma.f[0]++;
    cov_19u8wzgkma.s[1]++;
    angular.module('app').controller('AuthLogoutController', Controller);

    /* @ngInject */
    function Controller($rootScope, $state, AuthService) {
        cov_19u8wzgkma.f[1]++;

        var vm = (cov_19u8wzgkma.s[2]++, this);
        cov_19u8wzgkma.s[3]++;
        vm.title = 'Logout';
        cov_19u8wzgkma.s[4]++;
        vm.logout = logout;

        cov_19u8wzgkma.s[5]++;
        activate();

        function activate() {
            cov_19u8wzgkma.f[2]++;
            cov_19u8wzgkma.s[6]++;

            vm.logout();
        }

        function logout() {
            cov_19u8wzgkma.f[3]++;
            cov_19u8wzgkma.s[7]++;

            AuthService.logout().then(function () {
                cov_19u8wzgkma.f[4]++;
                cov_19u8wzgkma.s[8]++;

                $rootScope.profileMenuPageActive = false;
                cov_19u8wzgkma.s[9]++;
                $state.go('login');
            });
        }
    }
})();